// extracted by mini-css-extract-plugin
export default {"container":"Message_container__BQLjT","container-warning":"Message_container-warning__LN567","icon":"Message_icon__i7irZ","icon-warning":"Message_icon-warning__Q5glb"};